import { merge } from '../helper';

import setStyleData from './style/setStyleData';

// ----------------------------------------------------------------------------

function addBase64(element: HTMLElement, config: Record<string, any> = {}): void {
    // Default Config
    const defConfig: Record<string, any> = {
        backgroundImage: 'url(' + config.url + ')',
        backgroundPosition: config.position || '50%',
        backgroundSize: config.size || 'contain',
        backgroundRepeat: config.repeat || 'no-repeat',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    setStyleData(element, defConfig);
}

// ----------------------------------------------------------------------------

export default addBase64;
